export {default} from './CertificationContent';
